
/**
 * PC_SF_01 importing the api function calls and required functions from the components.
 */
import { useState, useEffect } from "react";
import React from "react";
import { postEmployeeSkillInfo } from "../service/DirectorAPI";
import $ from 'jquery';
import { encryptStorage } from '../constant'

/**
 * PC_SF_02 SkillDetails function contains the variables abe return the HTML
 */
export function SkillDetails(props) {

    /**
     * PC_SF_03 Declaring the State variables and objects
     */
    let dataObj = {
        id: "",
        NameOfSkill: "",

    };

    let validationFields = {
        NameOfSkill: ""
    }

    const [SkillData, setSkillData] = useState(dataObj);
    const [EmpId, setEmpId] = useState(props.empId);
    const [hideForm, setHideForm] = useState(true);
    let loginEmpId = encryptStorage.getItem("employeeId")
    let role = encryptStorage.getItem("role")
    const [message, setmessage] = useState(validationFields);
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);

    /**
     * PC_SF_03.1 useEffect method get invocked and set the values into the variabeles
     * remove the browser scroll bar
     */
    useEffect(() => {
        setDisableSubmitBtn(false);

        if (props.IsSkillClick) {

            $("body").addClass("removeScroll");
            setEmpId(props.empId);
            setHideForm(false);
        }

    }, [props]);

    /**
     * 
     * PC_SF_04 set the value into respective stste variable
     */
    const OnChangeName = (e) => {
        setSkillData({ ...SkillData, [e.target.name]: e.target.value });
    };


    /**
     * PC_SF_05 validate the state variable and set the error message 
     * if the variable have the null value
     */
    const validation = () => {

        if (SkillData.NameOfSkill.trim() == "") {

            message.NameOfSkill = "Listing your skills is required"
            setmessage({ ...message });
        } else {
            message.NameOfSkill = ""
            setmessage({ ...message });


        }
    }

    /**
     * PC_SF_13 this function clear the state variable value and close the form
     */
    const cancelClick = () => {

        let dataObj = {
            id: "",
            NameOfSkill: "",

        };
        setSkillData(dataObj);
        let validationFields = {
            NameOfSkill: ""
        }
        setmessage(validationFields);
        props.setIsSkillClicked(false);
        setHideForm(true);
        $("body").removeClass("removeScroll");


    }

    /**
     * PC_SF_06 this function post the data into the database
     */
    const submitClick = async () => {
        try {
              setDisableSubmitBtn(true);
            validation();

            if (
                SkillData.NameOfSkill.trim() != ""
            ) {
                let insertdata = {
                    request_type: "Insert",
                    emp_id: EmpId,
                    login_emp_id: loginEmpId,
                    role: role,
                    skill_name: SkillData.NameOfSkill
                };

                let responsedata = await postEmployeeSkillInfo(insertdata);
                if (responsedata.data.status == 200) {
                    // let valiclearoption = {
                    //     id: "",
                    //     NameOfSkill: ""
                    // };
                    // setSkillData(valiclearoption);
                    props.setIsSkillClicked(false);
                    props.getEmployeeSkills();
                    cancelClick();
                    // props.showToast();
                    props.showToast('Submitted', 'Submitted Succesfully');
                }

            }
             setDisableSubmitBtn(false);
        } catch (e) {
            setDisableSubmitBtn(false);

        }


    }


    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="SkillDetailsPopupLabel">
                            Skills
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-1">
                            <div className="col-md-8 mb-4">
                                <label htmlFor="skills-yourskill" className="form-label hive-form-label">
                                    Enter your Skills<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="skills-yourskill"
                                    aria-describedby="Enter your Skills"
                                    maxLength={225}
                                    placeholder="Enter here"
                                    name="NameOfSkill"
                                    value={SkillData.NameOfSkill}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.NameOfSkill ? <label className="hive-form-mandatory">{message.NameOfSkill}</label> : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                            disabled={DisableSubmitBtn}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SkillDetails;